import { Office } from "@/api/offices";
import { CodependentRenterRequisitesHandbook } from "@/app/components/handbooks/renterRequisitesHandbook";
import {
  CodependentHandbookProps,
  ModalBuilder,
} from "@/app/components/modals/modalBuilder";
import { useAppSelector } from "@/hooks/useAppSelector";
import { getRussianMonthNumber } from "@/utils";
import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
  Button,
  useDisclosure,
} from "@heroui/react";
import { useCallback, useMemo } from "react";

function CodependentOfficeTest(
  props: CodependentHandbookProps & AutocompleteProps<Office>,
) {
  const items = useAppSelector((state) => state.handbooks.office);
  const rents = useAppSelector((state) => state.handbooks.agreements);

  const finalItems = useMemo(() => {
    const [renter, month] = props.deps;
    const monthNumber = getRussianMonthNumber(month);

    console.log(renter, month, monthNumber);

    const rent = rents.find(
      (r) =>
        r.renterId == Number(renter) &&
        new Date(r.startDate).getMonth() == monthNumber,
    );

    console.log(new Date(rent?.startDate || ""));
    return items.filter((o) => o.id == rent?.id);
  }, [props.deps, rents, items]);

  return (
    <Autocomplete
      defaultItems={finalItems}
      label="Офис"
      placeholder="Выберите офис"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

function TestModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const promise = useCallback((bebra: any) => {
    return new Promise<boolean>((res, _rej) => {
      res(true);
      alert(
        `${bebra.renter} ${bebra.requisite} ${bebra.month} ${bebra.payment}`,
      );
    });
  }, []);

  return (
    <ModalBuilder
      {...disclosure}
      title="Тестовый модаль"
      onSubmit={promise}
      isSensitiveData={false}
      modalErrors={[]}
      fields={[
        {
          label: "Выберите компанию",
          name: "phone",
          placeholder: "Компания",
          type: "phone",
        },
        {
          label: "Выберите компанию",
          name: "renter",
          placeholder: "Компания",
          type: "renter",
        },
        {
          label: "Выберите счёт",
          name: "requisite",
          placeholder: "Счёт",
          type: "codependent",
          deps: ["renter"],
          element: CodependentRenterRequisitesHandbook,
        },
        {
          label: "Месяц",
          name: "month",
          placeholder: "Месяц",
          type: "month",
        },
        {
          label: "Выберите офис",
          name: "office",
          placeholder: "Офис",
          type: "codependent",
          deps: ["renter", "month"],
          element: CodependentOfficeTest,
        },
      ]}
    />
  );
}

export function TestPage() {
  const disclosure = useDisclosure();

  return (
    <>
      <TestModal disclosure={disclosure} />
      <h1>Test Page</h1>
      <p>Test</p>

      <Button onClick={(_) => disclosure.onOpen()}>Открыть</Button>
    </>
  );
}
